import { toNDigits } from '@mail/cross-sizes-utils';

export const getSize = (size: number) =>
    toNDigits({
        bytes: size,
        maxDigitsCount: 3,
    }).value;

export const getSizeInteger = (size) => {
    if (Number.isInteger(size)) {
        return size;
    }

    return size ? size.original : 0;
};
